import { render, staticRenderFns } from "./FrequentList.vue?vue&type=template&id=7641a7b6&"
import script from "./FrequentList.vue?vue&type=script&lang=js&"
export * from "./FrequentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports